export default [
  {
    path: '/admin/departments',
    name: 'admin_departments',
    component: () => import('./DepartmentsAdmin.vue'),
    meta: {
      name: 'Admin - Setores',
    },
  },
]
